import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../../constants'
import MainModule from '../../../modules/main'
import { Locale } from '../../../modules/locale'
import { Routing } from '../../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'partnerSignupCompleted', {
  title: 'Demande envoyée!',
  requestSentMessage:
    "Nous avons bien reçu votre demande, vous recevrez un courriel à l'adresse fournie dès que nous aurons validé votre inscription.",
  homePageButton: "Page d'accueil",
})

Locale.getInstance().registerKeySet('en', 'partnerSignupCompleted', {
  title: 'Request sent!',
  requestSentMessage:
    'We have received your request, you will receive an email at the address provided as soon as we have validated your registration.',
  homePageButton: 'Home page',
})

export interface LvcPartnerSignupCompletedModalWrapper {}

export class LvcPartnerSignupCompletedModalWrapper extends MinzeElement {
  modalId = MODALS.PARTNER_SIGNUP_COMPLETED_MODAL

  onReady(): void | Promise<void> {}

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goToLastPage()
  }

  onClickPartnerPage() {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()
    routing.goTo(Routing.HOST)
  }

  html = () => `
    <lvc-modal is-fullscreen-modal-scrollable="true" background="transparent" is-fixed="false" modal-id="${this.modalId}" narrow="true">
      <div slot="lvc-modal-content">
        <lvc-success-screen
          data-id="partner-signup-completed-modal"
          data-title="${Locale.getKey('partnerSignupCompleted.title')}"
          data-text="${Locale.getKey('partnerSignupCompleted.requestSentMessage')}"
          data-button="${Locale.getKey('partnerSignupCompleted.homePageButton')}"
        ></lvc-success-screen>
      </div>
    </lvc-modal>
  `

  eventListeners: EventListeners = [
    ['#link-back', 'click', this.goBack],
    [
      window,
      'lvc:success-screen-primary-button-click:partner-signup-completed-modal',
      this.onClickPartnerPage.bind(this),
    ],
  ]
}
